import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import addAssessmentDialog from '../dialog.addAssessmentDialog';
import boardApproveDialog from '../dialog.boardApproveDialog';
import generateFullReportDialog from '../dialog.generateFullReportDialog';
import bcpEditAssessmentDocumentDialog from '../dialog.editAssessmentDocumentDialog';
import controller from './incomplete-assessment.controller';
import departmentResources from '../riskManagement/departmentResources';
import directive from './incomplete-assessment.directive';
import healthResources from '../riskManagement/externalResources/healthResources';
import impactAnalysis from '../impactAnalysis';
import authorityAndManagement from '../authorityAndManagement';
import riskManagement from '../riskManagement';
import riskThreatAssessment from '../riskThreatAssessment';
import riskMonitoringAndTesting from '../riskMonitoringAndTesting';
import assessmentDocument from '../assessmentDocument';

export default angular.module('app.components.advisory.bcp.incompleteAssessment', [
  addAssessmentDialog,
  alerts,
  bcpDataService,
  boardApproveDialog,
  confirmDialog,
  constants,
  departmentResources,
  generateFullReportDialog,
  bcpEditAssessmentDocumentDialog,
  healthResources,
  impactAnalysis,
  authorityAndManagement,
  ssDialogService,
  riskManagement,
  riskThreatAssessment,
  riskMonitoringAndTesting,
  assessmentDocument,
  userService,
])
  .directive('bcpIncompleteAssessment', directive)
  .controller('IncompleteAssessmentController', controller)
  .name;

console.log('app.components.advisory.bcp.incompleteAssessment created');
